<template>
  <div>
    <jkhclb />
  </div>
</template>

<script>
// 获取接口地址
import Jkhclb from '@/components/jkhcRequest/jkhclb.vue'

export default {
  name: 'Jkhc',
  components: {
    // sideMenu,
    // Header,
    Jkhclb
  },
  data() {
    return {}
  },
  created: function() {},
  methods: {}
}
</script>

<style scoped>
</style>
